var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-2",
          attrs: { slot: "activator", outline: "", color: "primary" },
          on: { click: _vm.open },
          slot: "activator"
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [_vm._v("note_add")]),
          _vm._v("New Item\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000px", scrollable: "" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("image-uploader", {
                                    attrs: {
                                      constImage: _vm.local.image,
                                      dialog: _vm.dialog,
                                      errorMsg: _vm.errorMsg
                                    },
                                    on: { image: _vm.assignImage }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Name",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "name", $$v)
                                      },
                                      expression: "local.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Service (Optional)" },
                                    model: {
                                      value: _vm.local.service,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "service", $$v)
                                      },
                                      expression: "local.service"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: { label: "Description (Optional)" },
                                    model: {
                                      value: _vm.local.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "description", $$v)
                                      },
                                      expression: "local.description"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("h3", [_vm._v("Type of Rigs")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      model: {
                                        value: _vm.local.rig,
                                        callback: function($$v) {
                                          _vm.$set(_vm.local, "rig", $$v)
                                        },
                                        expression: "local.rig"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.rigTypes.humanoid,
                                          value: _vm.rigTypes.humanoid
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.rigTypes.custom,
                                          value: _vm.rigTypes.custom
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Polygon Limitation")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Polygon Count",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.polygon_count,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "polygon_count",
                                          $$v
                                        )
                                      },
                                      expression: "local.polygon_count"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Dimension in meters")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Dimension X",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.dimension.X,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local.dimension, "X", $$v)
                                      },
                                      expression: "local.dimension.X"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Dimension Y",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.dimension.Y,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local.dimension, "Y", $$v)
                                      },
                                      expression: "local.dimension.Y"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Dimension Z",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.dimension.Z,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local.dimension, "Z", $$v)
                                      },
                                      expression: "local.dimension.Z"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Scale")]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Character scale",
                                      type: "number",
                                      min: "0"
                                    },
                                    model: {
                                      value: _vm.local.scale,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "scale", $$v)
                                      },
                                      expression: "local.scale"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("h3", [_vm._v("Attachments")]),
                                      _vm._v(" "),
                                      _c(
                                        "file-uploader",
                                        {
                                          on: { input: _vm.assignFBX },
                                          model: {
                                            value: _vm.local.fbx,
                                            callback: function($$v) {
                                              _vm.$set(_vm.local, "fbx", $$v)
                                            },
                                            expression: "local.fbx"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "File box",
                                                  readonly: "",
                                                  "prepend-icon": "attach_file"
                                                },
                                                model: {
                                                  value: _vm.local.fbx.fileName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.local.fbx,
                                                      "fileName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "local.fbx.fileName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "file-uploader",
                                        {
                                          on: { input: _vm.assignIOS },
                                          model: {
                                            value: _vm.local.asset_bundle.iOS,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.local.asset_bundle,
                                                "iOS",
                                                $$v
                                              )
                                            },
                                            expression: "local.asset_bundle.iOS"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "iOS Asset Bundle",
                                                  readonly: "",
                                                  "prepend-icon": "attach_file"
                                                },
                                                model: {
                                                  value:
                                                    _vm.local.asset_bundle.iOS
                                                      .fileName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.local.asset_bundle
                                                        .iOS,
                                                      "fileName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "local.asset_bundle.iOS.fileName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "file-uploader",
                                        {
                                          on: { input: _vm.assignAndroid },
                                          model: {
                                            value:
                                              _vm.local.asset_bundle.Android,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.local.asset_bundle,
                                                "Android",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "local.asset_bundle.Android"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Android Asset Bundle",
                                                  readonly: "",
                                                  "prepend-icon": "attach_file"
                                                },
                                                model: {
                                                  value:
                                                    _vm.local.asset_bundle
                                                      .Android.fileName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.local.asset_bundle
                                                        .Android,
                                                      "fileName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "local.asset_bundle.Android.fileName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "file-uploader",
                                        {
                                          on: { input: _vm.assignWebGL },
                                          model: {
                                            value: _vm.local.asset_bundle.WebGL,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.local.asset_bundle,
                                                "WebGL",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "local.asset_bundle.WebGL"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "WebGL Asset Bundle",
                                                  readonly: "",
                                                  "prepend-icon": "attach_file"
                                                },
                                                model: {
                                                  value:
                                                    _vm.local.asset_bundle.WebGL
                                                      .fileName,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.local.asset_bundle
                                                        .WebGL,
                                                      "fileName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "local.asset_bundle.WebGL.fileName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Select Materials")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.materials,
                                      label: "Select Materials",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.material,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "material", $$v)
                                      },
                                      expression: "local.material"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("popover", { attrs: { always: true } }, [
                                    _c("h3", [_vm._v("Interactive Surfaces")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.interactive_surfaces,
                                      label: "Interactive Surfaces",
                                      chips: "",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.local.interactive_surface,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.local,
                                          "interactive_surface",
                                          $$v
                                        )
                                      },
                                      expression: "local.interactive_surface"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _vm.showSaveButton
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.save }
                        },
                        [
                          this.saving
                            ? _c(
                                "v-flex",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("v-flex", [_vm._v("Save")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-112715ac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112715ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addCharacterModel.vue
// module id = null
// module chunks = 